module.exports = __webpack_public_path__ + "static/media/rod-vagg_200x200.6b3e2dda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/rod-vagg_200x200.jpg
// module id = 311
// module chunks = 0